
export const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-navy-900 to-navy-800 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/38c4b7aa-285c-49b4-a4e2-25a3feb3886d.png" 
                alt="DUVANKA DOO Logo" 
                className="w-8 h-8 object-contain mr-3"
              />
              <span className="text-xl font-bold">DUVANKA DOO</span>
            </div>
            <p className="text-gray-400 mb-6">
              Protecting Digital Privacy
            </p>
          </div>

          <div>
            <h5 className="text-white font-bold mb-4">Product</h5>
            <div className="space-y-2">
              <button 
                onClick={() => scrollToSection('vpn')}
                className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                VPN Features
              </button>
              <button 
                onClick={() => scrollToSection('features')}
                className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                Security
              </button>
              <span className="block text-gray-500">Global Servers</span>
            </div>
          </div>

          <div>
            <h5 className="text-white font-bold mb-4">Company</h5>
            <div className="space-y-2">
              <button 
                onClick={() => scrollToSection('about')}
                className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                About Us
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                Contact
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="block text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
              >
                FAQ
              </button>
            </div>
          </div>

          <div>
            <h5 className="text-white font-bold mb-4">Reach Us</h5>
            <div className="space-y-2 text-sm text-gray-400">
              <p>support@duvankadoo.com</p>
              <p>+1 3256664206</p>
              <p>Bulevar Oslobodilaca Cacka 105G<br />Cacak, 520288<br />Serbia</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm font-serif mb-4 md:mb-0">
            © 2025 DUVANKA DOO. All rights reserved.
          </p>
          
          <div className="flex items-center space-x-4">
            <a 
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-cyan-400 transition-colors text-sm cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
